import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
const EditorViewComponent = ({ content }) => {
  return (
    <div>
      <ReactQuill value={content} readOnly={true} theme={'bubble'} />
    </div>
  );
};

export default EditorViewComponent;
